import styled from 'styled-components';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    gap: 24px;
  }
`;

export default Body;
